module.exports = __webpack_public_path__ + "img/attic.343794dc.svg";